import { render } from "./time-refund.view.vue?vue&type=template&id=a3b0246a&ts=true"
import script from "./time-refund.view.vue?vue&type=script&lang=ts"
export * from "./time-refund.view.vue?vue&type=script&lang=ts"

import "./time-refund.view.vue?vue&type=style&index=0&id=a3b0246a&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__